import React from "react";

const AddCircle: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="add_circle">
      <path
        id="icon"
        d="M8.32578 12.6008H9.67578V9.67578H12.6008V8.32578H9.67578V5.40078H8.32578V8.32578H5.40078V9.67578H8.32578V12.6008ZM9.00603 16.2008C8.01503 16.2008 7.08203 16.0133 6.20703 15.6383C5.33203 15.2633 4.56641 14.7477 3.91016 14.0914C3.25391 13.4352 2.73828 12.6698 2.36328 11.7953C1.98828 10.9208 1.80078 9.98641 1.80078 8.99216C1.80078 7.99791 1.98828 7.06641 2.36328 6.19766C2.73828 5.32891 3.25391 4.56641 3.91016 3.91016C4.56641 3.25391 5.33178 2.73828 6.20628 2.36328C7.08078 1.98828 8.01516 1.80078 9.00941 1.80078C10.0037 1.80078 10.9352 1.98828 11.8039 2.36328C12.6727 2.73828 13.4352 3.25391 14.0914 3.91016C14.7477 4.56641 15.2633 5.33028 15.6383 6.20178C16.0133 7.07341 16.2008 8.00466 16.2008 8.99553C16.2008 9.98653 16.0133 10.9195 15.6383 11.7945C15.2633 12.6695 14.7477 13.4352 14.0914 14.0914C13.4352 14.7477 12.6713 15.2633 11.7998 15.6383C10.9282 16.0133 9.99691 16.2008 9.00603 16.2008Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default AddCircle;
